import api from './apiService';

export const getDocumentoVigente = async (tipo) => {
  const response = await api.get(`legal/documentos/${tipo}/`);
  return response.data;
};

export const getMeuStatusLegal = async () => {
  const response = await api.get('legal/meu-status/');
  return response.data;
};

export const aceitarAmbos = async (termosVersao, privacidadeVersao, contexto = 'reaceite') => {
  const response = await api.post('legal/aceitar-ambos/', {
    termos_versao: termosVersao,
    privacidade_versao: privacidadeVersao,
    contexto,
  });
  return response.data;
};

export const exportarMeusDados = async () => {
  const response = await api.get('legal/exportar-dados/', { responseType: 'blob' });
  const blob = new Blob([response.data], { type: 'application/json' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `saldo-ativo-meus-dados.json`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const solicitarExclusaoConta = async ({ senha, confirmacao }) => {
  const payload = { confirmacao };
  if (senha) payload.senha = senha;
  const response = await api.post('legal/solicitar-exclusao/', payload);
  return response.data;
};
